let XLSXPromise = import('xlsx'); // preload once if possible

const readExcel = (file, cb) => {
  if (!file) {
    cb();
    return;
  }

  // Dynamic import, XLSX loaded as side-effect
  //   defined as external for esbuild & conencted using importmap 
  XLSXPromise.then((XLSX) => { 
    const xlsx = XLSX.default;
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;
    reader.onload = (e) => {
      const bstr = e.target.result;
      const wb = xlsx.read(bstr, {
        type: rABS ? 'binary' : 'array',
        bookSheets: true, // Only parse sheet names
        // cellDates: true,
        // dateNF: 'YYYY-MM-DD',
      });

      const ws_names = wb.SheetNames;

      // readData(wb, ws_name, (data, col_names) => {
        cb(ws_names);
      // })
    };

    if (rABS) reader.readAsBinaryString(file);
    else reader.readAsArrayBuffer(file);
  }).catch((err) => {
    console.error('Error loading XLSX library:', err);
    cb(); // Optionally handle the error case by calling the callback without arguments
  });
  
};


export const readExcelSheetNames = async (file) => {
  if (!file) return [];

  const XLSX = (await XLSXPromise).default;

  const buffer = await file.arrayBuffer();
  try {
    const wb = XLSX.read(buffer, {
      type: 'array',
      bookSheets: true, // Only sheet names
    });
    return wb.SheetNames;
  } catch (err) {
    console.error('Error reading Excel file:', err);
    return [];
  }
};


const readWorkSheet = (file,ws_name,cb) => {
  const reader = new FileReader();
  const rABS = !!reader.readAsBinaryString;
  reader.onload = (e) => {
    const bstr = e.target.result;
    const wb = XLSX.read(bstr, {
      type: rABS ? 'binary' : 'array',
      sheets: ws_name, // Only parse sheet names
    });

    
    readCells(wb, ws_name, (data, col_names) => {
      cb(data, col_names);
    })
  };

  if (rABS) {
    reader.readAsBinaryString(file);
  } else {
    reader.readAsArrayBuffer(file);
  }
}

const readCells = (wb, ws_name, cb) => {
  import('xlsx').then((xlsx) => {
    const XLSX = xlsx.default;
    const ws = wb.Sheets[ws_name];
  
    const col_names = Array.from({
      length: XLSX.utils.decode_range(ws['!ref']).e.c + 1
    }, (x, i) => {
      let label = XLSX.utils.encode_col(i);
      return ({label: label, value: i + 1, col_name: label})
    });
  
    const fillMerges = (ws) => {
      if (ws['!merges']) {
        for (let merge of ws['!merges']) {
          for (let i1 = merge.s.c; i1 <= merge.e.c; i1++) {
            for (let i2 = merge.s.r; i2 <= merge.e.r; i2++) {
              XLSX.utils.sheet_add_aoa(
                ws,
                [[ws[XLSX.utils.encode_col(merge.s.c) + XLSX.utils.encode_row(merge.s.r)]?.v || '']],
                {origin: XLSX.utils.encode_col(i1) + XLSX.utils.encode_row(i2)}
              )
            }
          }
        }
      }
    };
  
    /* Fill merged blocks */
    fillMerges(ws);
  
    /* Parse data */
    let data = XLSX.utils.sheet_to_json(ws, { header: 1, raw: false, blankrows: false, skipHidden: true });
  
    // Trim whitespace for each cell
    for (let i = 0; i < data.length; i++) {
      for (let j = 0; j < data[i].length; j++) {
        if (typeof data[i][j] === 'string') {
          data[i][j] = data[i][j].trim(); // Trim whitespace
        }
      }
    }
  
    /* Apply hotfix for incorrect parsing of dates */
    //data = data.map((arr) => arr.map((v) => {
    //  return (v instanceof Date) ? moment(v).add(1, 'minutes').format('YYYY-MM-DD HH:mm') : v;
    //}));
  
    /* Remove empty rows */
    data = data.filter((row) => row.length >= 1);
  
    cb(data, col_names);

  })
};

export { readExcel, readWorkSheet };
